module.exports = __webpack_public_path__ + "img/form-header-icon.c053ecf5.svg";